export default __webpack_public_path__ + "static/media/Gauntlets of the Tireless Defender.4914f4ae.jpg";